<template>
  <div>
    <input v-model="query" type="text" class="tw-w-full tw-p-4 tw-bg-light-4 tw-rounded" :placeholder="placeholder">
    <div class="tw-divide-y tw-divide-light-3 tw-overflow-auto tw-my-5">
      <div v-if="loading" class="tw-p-4 tw-h-36 tw-flex tw-items-center tw-justify-center tw-text-center tw-font-bold">
        <div>Searching..</div>
      </div>
      <div v-else-if="options.length === 0" class="tw-p-4 tw-text-center tw-font-bold">No matches found</div>
      <slot v-else v-for="option in options" name="option" v-bind:option="option"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      search: {},
      placeholder: {},
    },
    data: v => ({
      query: '',
      options: [],
      loading: false,
    }),
    created() {
      this.$watch('query',this.searchProxy)
      this.searchProxy('')
    },
    methods: {
      searchProxy(query) {
        this.loading = true
        this.search(query, options => {
          this.$set(this, 'options', options)
          this.loading = false
        })
      }
    }
  }
</script>
